var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _g3, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 216,
    viewBox: "0 0 391 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.569 115.397H390.033C383.683 80.9278 367.07 77.0178 347.4 94.8365C347.4 54.9247 318.978 41.9232 295.696 71.857C277.554 12.8965 201.513 32.9789 202.569 115.397Z",
    fill: "#307FE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.055 80.7475V95.4785C150.944 95.5821 149.833 95.6902 148.723 95.8028C141.199 96.5658 135.209 102.443 134.302 109.951C133.201 119.07 132.653 129.882 132.653 142.397C132.653 146.884 132.724 150.865 132.865 154.343C133.328 165.72 142.17 174.983 153.513 175.973C167.14 177.163 179.587 177.758 190.859 177.758C202.128 177.758 214.571 177.163 228.192 175.974C239.521 174.985 248.358 165.744 248.839 154.382C248.99 150.812 249.066 146.713 249.066 142.082C249.066 129.653 248.522 118.943 247.432 109.945C246.523 102.44 240.534 96.5676 233.013 95.8045C231.897 95.6913 230.781 95.5826 229.663 95.4785V80.7475C229.663 59.3166 212.29 41.9434 190.859 41.9434C169.428 41.9434 152.055 59.3166 152.055 80.7475ZM183.1 136.37C183.914 136.98 184.392 137.938 184.392 138.955V151.889C184.392 155.46 187.288 158.356 190.859 158.356C194.431 158.356 197.327 155.46 197.327 151.889V138.955C197.327 137.938 197.805 136.98 198.618 136.37C201.855 133.938 203.794 130.143 203.794 126.019C203.794 118.876 198.003 113.084 190.859 113.084C183.716 113.084 177.925 118.876 177.925 126.019C177.925 130.143 179.864 133.938 183.1 136.37ZM177.925 80.747V93.8795C182.226 93.7477 186.538 93.6817 190.859 93.6817C195.181 93.6817 199.492 93.7477 203.794 93.8795V80.747C203.794 73.6034 198.003 67.8123 190.859 67.8123C183.716 67.8123 177.925 73.6034 177.925 80.747Z",
    fill: "#FFBE9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7893 201.707H187.296C179.412 178.317 172.342 175.889 156.455 184.775C143.756 127.931 86.6096 134.583 69.6774 178.123C48.177 164.394 40.7152 171.548 32.7893 201.707Z",
    fill: "#83B2EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.505 205.162L302.433 183.699L290.55 177.647C290.126 189.141 294.276 195.802 306.505 205.162Z",
    fill: "#AFA5EF",
    stroke: "#AFA5EF",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.318 201.505L277.172 190.505L264.473 189.598L269.318 201.505Z",
    fill: "#AFA5EF",
    stroke: "#AFA5EF",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17370_44952",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 273,
    y: 163,
    width: 32,
    height: 34
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.778 176.294L274.048 191.732L281.525 195.104C295.775 201.53 309.84 185.815 301.879 172.363L297.876 165.599C296.598 163.438 293.879 162.614 291.616 163.7C289.544 164.695 288.457 167.009 289.015 169.238L290.778 176.294Z",
    fill: "#FFC000",
    stroke: "#FFC000",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17370_44952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.778 176.294L274.048 191.732L281.525 195.104C295.775 201.53 309.84 185.815 301.879 172.363L297.876 165.599C296.598 163.438 293.879 162.614 291.616 163.7C289.544 164.695 288.457 167.009 289.015 169.238L290.778 176.294Z",
    fill: "#AFA5EF",
    stroke: "#AFA5EF",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.613 176.898C296.053 179.946 284.908 188.046 282.917 204.538C289.503 201.21 303.767 194.848 303.935 194.764C304.103 194.68 306.528 182.994 307.613 176.898Z",
    fill: "#6254B6"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M291.679 170.542C290.871 172.05 289.939 172.835 289.354 173.211C289.056 173.403 288.713 173.219 288.707 172.865C288.696 172.169 288.833 170.959 289.64 169.451C289.942 168.888 290.643 168.676 291.205 168.977C291.768 169.279 291.98 169.98 291.679 170.542Z",
    fill: "#6254B6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M289.238 207.444L292.493 176.293L281.005 187.117C280.757 198.616 283.484 202.654 289.238 207.444Z",
    fill: "#AFA5EF",
    stroke: "#AFA5EF",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.729 27.3871L120.239 22.564L94.6848 4.06348C92.8298 12.8448 94.1274 17.9213 102.729 27.3871Z",
    fill: "#AFA5EF",
    stroke: "#AFA5EF",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.806 18.4169L125.532 23.8889L119.728 32.5642C133.409 33.7272 136.657 26.9416 141.806 18.4169Z",
    fill: "#AFA5EF",
    stroke: "#AFA5EF",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5616 33.5125L101.088 28.3351L88.9641 18.001L88.5616 33.5125Z",
    fill: "#AFA5EF",
    stroke: "#AFA5EF",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17370_44952",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 8,
    width: 34,
    height: 31
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.693 20.836L97.1339 26.8473L101.48 32.137C111.294 44.0804 130.635 35.9844 129.014 20.6114L128.24 13.2668C127.961 10.6187 125.688 8.63283 123.027 8.71096C120.381 8.78862 118.236 10.8806 118.092 13.5238L117.693 20.836Z",
    fill: "#C4C4C4",
    stroke: "black",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17370_44952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.693 20.836L97.1339 26.8473L101.48 32.137C111.294 44.0804 130.635 35.9844 129.014 20.6114L128.24 13.2668C127.961 10.6187 125.688 8.63283 123.027 8.71096C120.381 8.78862 118.236 10.8806 118.092 13.5238L117.693 20.836Z",
    fill: "#AFA5EF",
    stroke: "#AFA5EF",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.404 26.638C122.69 24.245 109.109 26.5643 100.013 40.4644C107.392 40.4009 122.998 41.0224 123.186 41.0215C123.374 41.0207 130.728 31.6202 134.404 26.638Z",
    fill: "#6254B6"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.016 16.2481C126.594 17.8583 126.552 19.0752 126.439 19.7623C126.382 20.1113 126.015 20.243 125.748 20.0102C125.224 19.552 124.418 18.6396 123.84 17.0294C123.624 16.4285 123.936 15.7665 124.537 15.5507C125.138 15.335 125.8 15.6472 126.016 16.2481Z",
    fill: "#6254B6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.233 101.57L42.3779 98.3021L29.0877 106.85C40.4144 114.611 53.0788 109.937 59.233 101.57Z",
    fill: "#FCBB26",
    stroke: "#FCBB26",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.585 106.216L33.5732 95.9594L3.39062 86.7783C4.49323 95.6854 7.37169 100.064 18.585 106.216Z",
    fill: "#FCBB26",
    stroke: "#FCBB26",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53851 116.871L15.6161 107.862L2.35254 104.326L6.53851 116.871Z",
    fill: "#FCBB26",
    stroke: "#FCBB26",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_17370_44952",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 81,
    width: 32,
    height: 34
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0425 94.779L12.4761 107.779L18.1486 111.501C31.095 119.993 47.435 107.22 42.3185 92.6061L39.663 85.0214C38.8104 82.5863 36.2231 81.2218 33.7321 81.8935C31.5927 82.4704 30.1019 84.4049 30.0892 86.6207L30.0425 94.779Z",
    fill: "#FFC000",
    stroke: "#FFC000",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_17370_44952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0425 94.779L12.4761 107.779L18.1486 111.501C31.095 119.993 47.435 107.22 42.3185 92.6061L39.663 85.0214C38.8104 82.5863 36.2231 81.2218 33.7321 81.8935C31.5927 82.4704 30.1019 84.4049 30.0892 86.6207L30.0425 94.779Z",
    fill: "#FCBB26",
    stroke: "#FCBB26",
    strokeWidth: 0.302774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1684 101.578C35.6747 99.9223 23.7114 102.524 16.1924 115.227C22.74 114.876 36.6189 114.803 36.7858 114.795C36.9526 114.787 43.1047 106.148 46.1684 101.578Z",
    fill: "#D69702"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4738 85.0304C38.9649 84.1917 40.1718 84.0299 40.8681 84.0267C41.2218 84.0251 41.4128 84.3648 41.2278 84.6662C40.8634 85.2596 40.0984 86.2069 38.6072 87.0456C38.0507 87.3586 37.3459 87.1612 37.0329 86.6047C36.7199 86.0483 36.9173 85.3434 37.4738 85.0304Z",
    fill: "#D69702"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudLock);
export default __webpack_public_path__ + "static/media/cloud_lock.85d6ce5b2df1eda35f081d63c74906fa.svg";
export { ForwardRef as ReactComponent };